<template>
  <div class="User-Tips">
    <ModalTips :id="'UserSettingTips'" v-model="temp_value">
      <template v-slot:Title>
        <div class="ModalTipsTilte" v-if="[0, 1].includes(type)">
          <template v-if="type == 0">
            {{ (emailMobileData && emailMobileData.phoneIsVerify) ? $t('lbl_emp2_MobileNo') : $t('EMP_UserSetting_MobileNo') }}
          </template>
          <template v-else>
            {{ (emailMobileData && emailMobileData.emailIsVerify) ? $t('lbl_emp2_Email') : $t('EMP_UserSetting_Email') }}
          </template>
        </div>
        <div class="ModalTipsTilte" v-if="type == 3">{{ $t('EMP_UserSetting_RetrievePasswordTitle') }}</div>
        <div class="ModalTipsTilte" v-if="type == 2">{{ $t('EMP_UserSetting_SetUpPassword') }}</div>
      </template>
      <template v-slot:Content>
        <div class="ModalTipsContent">
          <!--邮箱和手机使用-->
          <div class="ModalTipsContent-Item" v-if="[0, 1].includes(type)">
            <span v-if="type == 0 && !(emailMobileData && emailMobileData.phoneIsVerify)">{{ $t('EMP_UserSetting_MobileTip') }}</span>
            <span v-else-if="type == 0 && (emailMobileData && emailMobileData.phoneIsVerify)"></span>
            <span v-else-if="type == 1 && !(emailMobileData && emailMobileData.emailIsVerify)">{{ $t('EMP_UserSetting_EmailTip') }}</span>
            <span v-else-if="type == 1 && (emailMobileData && emailMobileData.emailIsVerify)"></span>
            <Verification ref="VerificationRef" :isInternalValue="true" :optType="optType" :isLoginUse="false"
              v-model="emailMobileData" :captchaVerifyParam="captchaVerifyParam"></Verification>
          </div>
          <!--设置密码-->
          <div class="ModalTipsContent-Item" v-if="type == 2">
            <DuplicatePassword :new-password="PasswordData.localNewPassword"
              :confirm-password="PasswordData.localConfirmPassword" @update:newPassword="handleNewPasswordUpdate"
              @update:confirmPassword="handleConfirmPasswordUpdate"
              @update:passwordStrength="handlePasswordStrengthUpdate" />
          </div>
          <!--找回密码-->
          <div class="ModalTipsContent-Item" v-if="type == 3">
            {{ $t('EMP_UserSetting_RetrievePasswordTip') }}
            <div style="margin-top: 8px;">{{ $t('EMP_UserSetting_SelectMobileOrEmail') }}</div>
            <a v-for="(item, index) in sortedContactList" :key="item.loginType + '_' + index" href="javaScript:;"
              :t_label="'EMP_UserSettingModal_RetrievePassword_' + item.loginType" @click="RetrievePassword(item)"
              class="ModalTipsContent-Item-FindPassword-Link">
              <div class="ModalTipsContent-Item-FindPassword">
                <i class="UserSetting_Email_Icon"
                  v-if="item.loginType == 'Email'"></i>
                <i class="UserSetting_phone_Icon"
                  v-if="item.loginType == 'Phone'"></i>
                <div class="ModalTipsContent-Item-FindPassword-P">
                  {{ formatContactDisplay(item) }}
                </div>
              </div>
            </a>
          </div>
        </div>
      </template>
      <template v-slot:leftFooter v-if="ShowRemoveButtom">
        <a href="javaScript:;" class="UserSetting_Remove" @click="RemoveFunc" t_label="EMP_UserSetting_Remove">
          {{ $t('EMP_UserSetting_Remove') }}
        </a>
      </template>
      <template v-slot:MiddleFooter v-if="ShowCancelButtom">
        <b-button
          variant="outline-secondary"
          class="UserSetting_Cancel"
          t_label="EMP_UserSetting_Cancel"
          @click="CancelFunc"
        >
          {{ $t('EMP_UserSetting_Cancel') }}
        </b-button>
      </template>
      <template v-slot:RightFooter v-if="ShowOkButtom">
        <b-button
          variant="primary"
          :t_label="OkButtonTLabel"
          @click="SaveFunc"
          class="UserSetting_Ok"
        >
          {{ OkButtonText }}
        </b-button>
      </template>
    </ModalTips>
  </div>
</template>

<script>
import { CompanyInfoService, userService } from "../../_services";
import ModalTips from '@/components/UserSetting/ModalTips.vue';
import Verification from '@/components/UserSetting/Verification.vue';
import DuplicatePassword from '@/components/UserSetting/DuplicatePassword.vue';
import { AlertDialog } from "../../_helpers/AlertDialog";
import { getContactUsConfig, DEFAULT_SHOW_ID } from '../../components/new-login/Common/new-login-config.js';
export default {
  mixins: [AlertDialog],
  props: {
    //0 mobileVerification, 1 emailVerification, 2 SetPassword，3 FindPassword
    type: {
      type: Number,
      default: 0
    },
    value:
    {
      type: Boolean,
      default: false
    },
    captchaVerifyParam: {
      type: Object,
      default: function () {
        return {}
      }
    },
    contactList: {
      type: Array,
      default: () => []
    },
    emailMobileData: {
      type: Object,
      default: function () {
        return {
          emailInput: '2213939679@qq.com',
          mobileInput: '17681055738',
          contactPhoneCountryCode: '44',
          contactPhoneCountry: '86',
          emailIsVerify: false,
          phoneIsVerify: false
        }
      }
    },
    isEBoothRep: {
      type: Boolean,
      default: false
    },
    isContactPerson: {
      type: Boolean,
      default: false
    },
    hasPhone: {
      type: Boolean,
      default: false
    },
    hasEmail: {
      type: Boolean,
      default: false
    },
  },
  components: {
    ModalTips,
    Verification,
    DuplicatePassword
  },
  data() {
    return {
      PasswordData: {
        localNewPassword: '',
        localConfirmPassword: '',
        passwordStrength: ''
      },
      cellCountryOptions: [],
      temp_value: this.value,
      retrieving: false // 找回密码加载状态
    }
  },
  computed: {
    optType() {
      return this.type == 0 ? 'mobile' : 'email';
    },
    ShowCancelButtom() {
      // 手机/邮箱：如果已经设置好了（有值且已验证），则不显示取消按钮
      // 如果没有设置好（没有值或未验证），则显示取消按钮
      if ([0, 1].includes(this.type)) {
        if (this.type === 0) {
          // 手机号：已经设置好了（有值且已验证）时不显示取消
          const isSet = !!(this.emailMobileData && this.emailMobileData.mobileInput && this.emailMobileData.phoneIsVerify);
          return !isSet;
        }
        if (this.type === 1) {
          // 邮箱：已经设置好了（有值且已验证）时不显示取消
          const isSet = !!(this.emailMobileData && this.emailMobileData.emailInput && this.emailMobileData.emailIsVerify);
          return !isSet;
        }
      }
      // 其他类型（密码设置等）显示取消按钮
      return true;
    },
    ShowRemoveButtom() {
      // 找回密码和设置密码不需要 Remove 按钮
      if ([3, 2].includes(this.type)) {
        return false;
      }
      // 对于手机号 (type 0)，只有当已设置（有值）时才显示删除按钮
      if (this.type === 0) {
        return !!(this.emailMobileData && this.emailMobileData.mobileInput);
      }
      // 对于邮箱 (type 1)，只有当已设置（有值）时才显示删除按钮
      if (this.type === 1) {
        return !!(this.emailMobileData && this.emailMobileData.emailInput);
      }
      return false;
    },
    ShowOkButtom() {
      return ![3].includes(this.type);
    },
    OkButtonText() {
      // 手机/邮箱场景：如果已经设定好（有值且已验证），显示"好的"；如果还没设定好，显示"保存"
      if ([0, 1].includes(this.type)) {
        let isSetUp = false;
        if (this.type === 0) {
          // 手机号：有输入值且已验证才算设定好
          isSetUp = !!(this.emailMobileData && this.emailMobileData.mobileInput && this.emailMobileData.phoneIsVerify);
        } else if (this.type === 1) {
          // 邮箱：有输入值且已验证才算设定好
          isSetUp = !!(this.emailMobileData && this.emailMobileData.emailInput && this.emailMobileData.emailIsVerify);
        }
        return isSetUp ? this.$t('EMP_UserSetting_OK') : this.$t('EMP_UserSetting_Save');
      }
      // 其他场景（如密码设置）使用保存文案
      return this.$t('EMP_UserSetting_Save');
    },
    OkButtonTLabel() {
      if ([0, 1].includes(this.type)) {
        let isSetUp = false;
        if (this.type === 0) {
          // 手机号：有输入值且已验证才算设定好
          isSetUp = !!(this.emailMobileData && this.emailMobileData.mobileInput && this.emailMobileData.phoneIsVerify);
        } else if (this.type === 1) {
          // 邮箱：有输入值且已验证才算设定好
          isSetUp = !!(this.emailMobileData && this.emailMobileData.emailInput && this.emailMobileData.emailIsVerify);
        }
        return isSetUp ? 'EMP_UserSetting_OK' : 'EMP_UserSetting_Save';
      }
      return 'EMP_UserSetting_Save';
    },
    // 对 contactList 进行排序，使 Mobile No 和 Email 交替显示
    sortedContactList() {
      if (!this.contactList || this.contactList.length === 0) {
        return [];
      }
      
      // 分离 Phone 和 Email
      const phones = this.contactList.filter(item => item.loginType === 'Phone');
      const emails = this.contactList.filter(item => item.loginType === 'Email');
      
      // 交替合并：先 Phone，再 Email，再 Phone，再 Email...
      const result = [];
      const maxLength = Math.max(phones.length, emails.length);
      
      for (let i = 0; i < maxLength; i++) {
        if (i < phones.length) {
          result.push(phones[i]);
        }
        if (i < emails.length) {
          result.push(emails[i]);
        }
      }
      
      return result;
    }
  },
  watch: {
    value(newVal) {
      this.temp_value = newVal;
    },
    temp_value: {
      handler() {
        this.InitPasswordData();
        this.$emit('input', this.temp_value);
      }, deep: true

    }
  },
  created() {

  },
  mounted() {
    this.getCellCountryOptions();
  },
  methods:
  {
    InitPasswordData() {
      this.PasswordData = {
        localNewPassword: '',
        localConfirmPassword: '',
        passwordStrength: ''
      }
    },
    async RemoveFunc() {
      if ([0, 1].includes(this.type)) {
        // 检查用户是否是展台代表或联系人
        const isEBoothRep = this.isEBoothRep;
        const isContactPerson = this.isContactPerson;
        
        // 检查删除后是否还有至少一种联系方式
        let willHaveContact = false;
        if (this.type == 0) {
          // 删除手机号，检查是否还有邮箱
          willHaveContact = this.hasEmail;
        } else if (this.type == 1) {
          // 删除邮箱，检查是否还有手机号
          willHaveContact = this.hasPhone;
        }
        
        // 如果是展台代表或联系人，且删除后没有联系方式，则不允许删除，直接显示弹框
        if ((isEBoothRep || isContactPerson) && !willHaveContact) {
          await this.showOnlyOkShow(
            this.$t('EMP_UserSetting_MobileOrEmailCannotBeRemoved'),
            this.$t('EMP_UserSetting_MobileOrEmailCannotBeRemovedMsg'),
            this.$t('lbl_EMPBE_Confirm')
          );
          return;
        }
        
        // 根据类型确定提示文本
        const deleteType = this.type === 0 ? 'mobile' : 'email';

        let title;
        let text;
        let confirmButton;
        let cancelButton;

        if (deleteType === 'mobile') {
          // 手机号：使用专用文案（Remove This Mobile / Once deleted... / 我再想想 / 確認移除）
          title = this.$t('EMP_UserSetting_RemoveThisMobile');
          text = this.$t('EMP_UserSetting_RemoveMobileWarning');
          confirmButton = this.$t('EMP_UserSetting_ConfirmRemove');
          cancelButton = this.$t('EMP_UserSetting_ThinkAgain');
        } else {
          // 邮箱：使用专用文案（Remove This Email / Once deleted... / 我再想想 / 確認移除）
          title = this.$t('EMP_UserSetting_RemoveThisEmail');
          text = this.$t('EMP_UserSetting_RemoveEmailWarning');
          confirmButton = this.$t('EMP_UserSetting_ConfirmRemove');
          cancelButton = this.$t('EMP_UserSetting_ThinkAgain');
        }

        // 显示确认对话框
        const result = await this.showCustomConfirmDEL(title, text, confirmButton, cancelButton);

        // 如果用户确认删除，则执行删除操作
        if (result && result.value) {
          this.$emit("DelEmailMobile", this.emailMobileData);
        }
      }
    },
    SaveFunc() {
      if ([0, 1].includes(this.type)) {
        const verificationRef = this.$refs.VerificationRef;
        if (verificationRef && typeof verificationRef.validateForm === 'function') {
          const isValid = verificationRef.validateForm();
          if (!isValid) {
            return;
          }
        }
        this.$emit("SaveEmailMobile", this.emailMobileData);
      } else if ([2].includes(this.type)) {
        this.savePasswordDirectly();
      }
      // 点击 OK 后关闭弹框
      this.temp_value = false;
      this.$emit('input', false);
    },

    /**
     * 保存密码 - 直接保存，无需确认
     */
    async savePasswordDirectly() {
      // 验证密码是否填写
      if (!this.PasswordData.localNewPassword || !this.PasswordData.localConfirmPassword) {
        this.$Alert(0, this.$t('lbl_EMPBE_Please_mandatory_And_exceptions_Tips'));
        return;
      }

      // 验证密码是否匹配
      if (this.PasswordData.localNewPassword !== this.PasswordData.localConfirmPassword) {
        this.$Alert(0, this.$t('EMP_UserSetting_PasswordsDoNotMatch'));
        return;
      }

      // 验证密码长度（至少6位字符）
      if (this.PasswordData.localNewPassword.length < 6) {
        this.$Alert(0, this.$t('EMP_UserSetting_PasswordStrengthTip'));
        return;
      }

      const encryptPassword = await userService.EncryptText(this.PasswordData.localNewPassword);
      // 直接执行保存
      this.$emit("SavePassword", encryptPassword);

      // 显示成功提示框
      const successTitle = this.$t('EMP_UserSetting_PasswordUpdated');
      const successMessage = this.$t('EMP_UserSetting_PasswordUpdatedSuccess');
      this.showSubmitSucess(successTitle, successMessage);
    },

    /**
     * 保存密码 - 带确认提示框（已废弃，保留以防需要）
     */
    async savePasswordWithConfirm() {
      const title = this.$t('lbl_EMPBE_Confirm');
      const text = this.$t('lbl_EMPBE_ConfirmSavePassword');
      const confirmButton = this.$t('lbl_EMPBE_Confirm');

      // 显示确认对话框
      const result = await this.showOnlyOkShow(title, text, confirmButton);

      const encryptPassword = await userService.EncryptText(this.PasswordData.localNewPassword);
      // 如果用户确认保存，则执行保存操作
      if (result && result.value) {
        // 执行保存
        this.$emit("SavePassword", encryptPassword);

        // 显示成功提示框
        const successTitle = this.$t('EMP_UserSetting_PasswordUpdated');
        const successMessage = this.$t('EMP_UserSetting_PasswordUpdatedSuccess');
        this.showSubmitSucess(successTitle, successMessage);
      }
    },
    async getCellCountryOptions() {
      this.cellCountryOptions = (await CompanyInfoService.GetCellCountryData()).map(item => {
        return {
          id: item.Code,
          label: '+' + item.Option
        }
      });
    },
    /**
     * 格式化联系方式显示（为手机号添加国家代码前缀）
     * @param {Object} item - 联系方式对象，包含 loginType, value, phoneCountry
     * @returns {String} 格式化后的显示文本
     */
    formatContactDisplay(item) {
      if (!item || !item.value) return '';
      
      if (item.loginType === 'Phone') {
        const countryCode = item.countryCode || item.phoneCountry || item.phoneCountryCode;
        
        if (this.cellCountryOptions && this.cellCountryOptions.length > 0 && countryCode) {
          const countryOption = this.cellCountryOptions.find(opt => String(opt.id) === String(countryCode));
          const countryPrefix = countryOption ? countryOption.label : '+' + countryCode;
          return countryPrefix + ' ' + item.value;
        } else {
          return '+86 ' + item.value;
        }
      }
      
      return item.value;
    },
    handleNewPasswordUpdate(value) {
      this.PasswordData.localNewPassword = value;
    },
    handleConfirmPasswordUpdate(value) {
      this.PasswordData.localConfirmPassword = value;
    },
    handlePasswordStrengthUpdate(strength) {
      this.PasswordData.passwordStrength = strength;
    },
    /**
     * 找回密码 - 主入口
     * @param {Object} contactItem - 联系人信息对象，包含 loginType 和 value
     */
    async RetrievePassword(contactItem) {
      if (this.retrieving) return;

      // 验证联系人信息
      if (!contactItem || !contactItem.value) {
        this.$Alert(0, this.$t('lbl_EMPBE_InvalidContact'));
        return;
      }

      // 检查是否有验证码参数
      if (!this.captchaVerifyParam || !this.captchaVerifyParam.lot_number) {
        // 如果没有验证码参数，说明需要先触发验证码
        // 通过事件通知父组件显示验证码
        this.$emit('request-captcha', contactItem);
        return;
      }

      // 根据类型调用对应的处理方法
      const loginType = contactItem.loginType;
      if (loginType === 'Email') {
        await this.sendEmailRetrievePassword(contactItem);
      } else if (loginType === 'Phone') {
        await this.sendPhoneRetrievePassword(contactItem);
      }
    },

    /**
     * 发送邮箱找回密码
     * @param {Object} contactItem - 联系人信息对象，包含 value (邮箱地址)
     */
    async sendEmailRetrievePassword(contactItem) {
      this.retrieving = true;
      try {
        const langId = parseInt(localStorage.getItem('currentLangId')) || 1252;
        const captchaParam = this.captchaVerifyParam || {};

        // 构建邮箱找回密码参数
        const params = {
          channel: 'email',
          sendType: 'retrievePassword',
          typename: captchaParam?.typename || 'CPS_Login',
          lot_number: captchaParam?.lot_number || '',
          captcha_output: captchaParam?.captcha_output || '',
          pass_token: captchaParam?.pass_token || '',
          gen_time: captchaParam?.gen_time || '',
          email: contactItem.value.trim(),
          langId: langId
        };

        // 调用发送接口
        const res = await userService.sendVerification(params);

        if (res && res.isSuccessful) {
          // 发送成功，弹出成功提示框
          const successMessage = this.$t('EMP_UserSetting_PasswordSentToEmail');
          this.showOnlyOkShow(this.$t('EMP_UserSetting_CheckYourMailbox'), successMessage, this.$t('lbl_EMPBE_Confirm'));
          // 关闭当前弹窗
          this.temp_value = false;
        } else {
          // 发送失败
          const errorMsg = res?.systemErrorMsg?.join(';') || res?.msg?.join(';') ||
            this.$t('lbl_EMPBE_SendFailed');

          this.$Alert(0, errorMsg);
        }
      } catch (error) {
        console.error('Send email retrieve password error:', error);

        this.$Alert(0, error.message || this.$t('lbl_EMPBE_NetworkError'));
      } finally {
        this.retrieving = false;
      }
    },

    /**
     * 发送手机号找回密码
     * @param {Object} contactItem - 联系人信息对象，包含 value (手机号) 和可能的 countryCode
     */
    async sendPhoneRetrievePassword(contactItem) {
      this.retrieving = true;
      try {
        const langId = parseInt(localStorage.getItem('currentLangId')) || 1252;
        const captchaParam = this.captchaVerifyParam || {};

        // 获取 showid 配置
        const contactUsConfig = getContactUsConfig('supplier');
        const showid = contactUsConfig?.showid || DEFAULT_SHOW_ID || '9991';
        const RLang = langId;

        // 从 contactItem 中提取手机号和国家码
        // 支持多种字段名：countryCode, phoneCountry, phoneCountryCode
        const countryCode = contactItem.countryCode || contactItem.phoneCountry || contactItem.phoneCountryCode || '86';
        const isInternational = countryCode !== '86';

        // 提取纯手机号（如果 value 中包含国家码，需要移除）
        let cellNum = contactItem.value.trim();
        // 如果 value 中包含国家码前缀，需要移除
        // 这里假设 value 是纯手机号，如果实际数据结构不同，需要调整

        // 获取电话区号（countryTelCode）
        // 从 cellCountryOptions 中查找对应的区号
        let countryTelCode = null;
        if (this.cellCountryOptions && this.cellCountryOptions.length > 0 && countryCode) {
          const countryOption = this.cellCountryOptions.find(opt => String(opt.id) === String(countryCode));
          if (countryOption && countryOption.label) {
            // 从 label 中提取区号（去掉 + 号）
            // label 格式如："+852"
            countryTelCode = countryOption.label.replace(/^\+/, '').trim();
          }
        }
        
        // 如果无法从 cellCountryOptions 中获取，尝试直接使用 countryCode（假设它就是区号）
        if (!countryTelCode && countryCode) {
          countryTelCode = String(countryCode).trim();
        }

        // 构建手机号找回密码参数
        const params = {
          channel: 'mobile',
          sendType: 'retrievePassword',
          typename: captchaParam?.typename || 'CPS_Login',
          lot_number: captchaParam?.lot_number || '',
          captcha_output: captchaParam?.captcha_output || '',
          pass_token: captchaParam?.pass_token || '',
          gen_time: captchaParam?.gen_time || '',
          CellNum: cellNum,
          showid: showid.toString(),
          RLang: RLang,
          isInternational: isInternational ? 'true' : 'false',
          langId: langId
        };

        // 添加 countryTelCode 参数（如果存在）
        if (countryTelCode) {
          params.countryTelCode = countryTelCode;
        }

        // ===== 体验优化：先立即提示“检查你的SMS”，再异步发送 =====
        // 1）先立即弹出成功提示，避免用户等待接口返回
        const successMessage = this.$t('EMP_UserSetting_PasswordSentToMobile');
        this.showOnlyOkShow(this.$t('EMP_UserSetting_CheckYourSMS'), successMessage, this.$t('lbl_EMPBE_Confirm'));
        // 2）关闭当前“找回密码”选择弹窗
        this.temp_value = false;

        // 调用发送接口
        const res = await userService.sendVerification(params);

        if (res && res.isSuccessful) {
          // 接口成功：此处不再重复弹窗，只在控制台记录成功日志
          console.info('Send phone retrieve password success');
        } else {
          // 发送失败
          const errorMsg = res?.systemErrorMsg?.join(';') || res?.msg?.join(';') ||
            this.$t('lbl_EMPBE_SendFailed');

          this.$Alert(0, errorMsg);
        }
      } catch (error) {
        console.error('Send phone retrieve password error:', error);
        this.$Alert(0, error.message || this.$t('lbl_EMPBE_NetworkError'));
      } finally {
        this.retrieving = false;
      }
    },
    CancelFunc() {
      this.temp_value = false;
    }
  }, 
};
</script>
<style scoped>
.ModalTipsContent-Item-FindPassword-Link {
  display: block;
  text-decoration: none;
  cursor: pointer;
}

.ModalTipsContent-Item-FindPassword-Link:hover .ModalTipsContent-Item-FindPassword {
  border-color: rgba(0, 0, 0, 0.40);
}



.ModalTipsContent-Item-FindPassword-P {
  color: rgba(0, 0, 0, 0.80);
  font-size: 14px;
  font-weight: 400;
  line-height: 24px;
  word-wrap: break-word;
  flex: 1;
}

.ModalTipsContent-Item-FindPassword {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px;
  border: 1px solid rgba(0, 0, 0, 0.23);
  border-radius: 8px;
  background: #FFFFFF;
  min-height: 48px;
  box-sizing: border-box;
}

.ModalTipsContent-Item-FindPassword i {
  width: 30px;
  height: 25px;
  background: rgba(0, 0, 0, 0.80);
  flex-shrink: 0;
}

.ModalTipsTilte {
  color: rgba(0, 0, 0, 0.80);
  font-size: 18px;
  font-weight: 700;
  line-height: 23.40px;
  word-wrap: break-word
}

.ModalTipsContent {
  color: rgba(0, 0, 0, 0.60);
  font-size: 14px;
  font-weight: 400;
  line-height: 18.20px;
  word-wrap: break-word
}

.ModalTipsContent-Item {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

/* ===== UserSettingTips Footer Buttons ===== */
/* 口径：尺寸回到“原来版本”（跟随 .btn：padding .375rem 1.75rem / line-height 1.5 / radius .25rem / font-size 14px） */
.UserSetting_Ok {
  /* 尺寸：与原版 .btn 保持一致，且与 Cancel 完全一致 */
  padding: 0.375rem 1.75rem !important;
  line-height: 1.5 !important;
  border-radius: 0.25rem !important;
  font-size: 14px !important;
  font-family: Inter, sans-serif !important;
  font-weight: 700 !important;
  box-shadow: none !important;
  border: none !important;
  background: #7366FF !important;
}
.UserSetting_Ok:hover:not(:disabled) {
  background: #4433FF !important;
}
.UserSetting_Ok:focus,
.UserSetting_Ok:active {
  box-shadow: none !important;
}
.UserSetting_Ok:disabled,
.UserSetting_Ok.disabled {
  background: #9EA5A8 !important;
  opacity: 1 !important;
  cursor: not-allowed !important;
}

/* Cancel：尺寸同 OK/Save；无下划线；hover 灰底（只改样式，不改尺寸） */
.UserSetting_Cancel {
  padding: 0.375rem 1.75rem !important;
  line-height: 1.5 !important;
  border-radius: 0.25rem !important;
  border: none !important;
  background: transparent !important;
  color: rgba(0, 18, 26, 0.60) !important;
  font-size: 14px !important;
  font-family: Inter, sans-serif !important;
  font-weight: 700 !important;
  text-decoration: none !important;
  box-shadow: none !important;
}

.UserSetting_Cancel:hover:not(:disabled):not(.disabled) {
  background: rgba(0, 18, 26, 0.05) !important;
  color: rgba(0, 18, 26, 0.60) !important;
  text-decoration: none !important;
  border: none !important;
}

.UserSetting_Cancel:focus:not(:disabled):not(.disabled) {
  background: rgba(0, 18, 26, 0.05) !important;
  color: rgba(0, 18, 26, 0.60) !important;
  text-decoration: none !important;
  border: none !important;
  box-shadow: none !important;
}

.UserSetting_Cancel:active:not(:disabled):not(.disabled) {
  background: rgba(0, 18, 26, 0.05) !important;
  color: rgba(0, 18, 26, 0.60) !important;
  text-decoration: none !important;
  border: none !important;
}

.UserSetting_Cancel:disabled,
.UserSetting_Cancel.disabled {
  background: transparent !important;
  cursor: not-allowed !important;
  opacity: 1 !important;
}

/* Remove：尺寸回原版 .btn（并保持与 Cancel/OK 一致的 padding/line-height/radius），只改颜色/hover */
.UserSetting_Remove {
  padding: 0.375rem 1.75rem !important;
  line-height: 1.5 !important;
  border-radius: 0.25rem !important;
  color: #DC3545 !important;
  font-size: 14px !important;
  font-family: Inter, sans-serif !important;
  font-weight: 700 !important;
  text-decoration: none !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  gap: 8px !important;
}
.UserSetting_Remove:hover:not(:disabled):not(.disabled),
.UserSetting_Remove:focus:not(:disabled):not(.disabled),
.UserSetting_Remove:active:not(:disabled):not(.disabled) {
  background: rgba(0, 18, 26, 0.05) !important;
  text-decoration: none !important;
}

.UserSetting_Remove:disabled,
.UserSetting_Remove.disabled {
  background: transparent !important;
  cursor: not-allowed !important;
  opacity: 1 !important;
}
</style>
